<template>
 <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item class='mb15' label="关键字" name='keywords'>
      <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入经销商编号进行搜索" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click='select(0)' v-if='mustShowHeadquarters'>选择总部</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
     <a-button type="primary" @click='select(record)' v-if='!checkout' :ghost="!record.select" >{{!record.select ? "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
   <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>


<script>
  import { ref, onMounted, inject, reactive, toRefs} from "vue";
  import { message } from "ant-design-vue";
//   import { getDealerListSelect } from "@/api/dealer";
import { getConsignee } from '@/api/antiFleeing.js'
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    type:1,
    keyword: "",
    page: 1,
    limit:5,
  };
  export default {
    name: "selectDealer",
    components: {},
    props: {
      levelid: Number,
      mustShowHeadquarters:{
        type:Boolean,
        defalut(){
          return false
        }
      },
       checkout:{
        type:Boolean,
        defalut:false
      },
      selectList:{
        type:Array
      },
    }, 
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        time: [],
        total: 1,
        selectedRowKeys: [],
        selectList:[],
      });
      let columns = [
        {
          title: "经销商编号",
          dataIndex: "code",
          key: "code",
        },
        {
          title: "经销商名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "经销商级别",
          dataIndex: "level",
          key: "level",
        },
        {
          title: "负责人",
          dataIndex: "clerk_name",
          key: "clerk_name",
        },
        {
          title: "手机号码",
          dataIndex: "clerk_phone",
          key: "clerk_phone",
        },
        {
          title: "操作",
          key: "action",
          width:120,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
       initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const select = (e) => {
        data.value.map(item => item.select = false)
        if(e!=0){
         e.select = !e.select
        }
        emit("select", e);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getConsignee(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data|| [];
            state.total = res.meta.total;

            if(state.selectList || state.selectList.length > 0){
              console.log('进')
              data.value.forEach(i=>{
                if( state.selectList.find(v=>{
                  return i.id == v.id || i.id==v.store_id
                })){
                  i.select=true
                }
              })
            }
            console.log(data.value,'1111111')
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      

      onMounted(() => {
         if(props.selectList){
           state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        search.value.level_id = props.levelid == undefined ? '' : props.levelid
        initData(search.value)
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select
      };
    },
  };
</script>